import * as React from "react";
import { useLicenseVerifier, MuiCommercialPackageName } from "../useLicenseVerifier";
import { LicenseStatus } from "../utils/licenseStatus";

function getLicenseErrorMessage(licenseStatus: LicenseStatus) {
  switch (licenseStatus) {
    case LicenseStatus.Expired:
      return "MUI X: License key expired";
    case LicenseStatus.Invalid:
      return "MUI X: Invalid license key";
    case LicenseStatus.NotFound:
      return "MUI X: Missing license key";
    default:
      throw new Error("MUI: Unhandled MUI X license status.");
  }
}

interface WatermarkProps {
  packageName: MuiCommercialPackageName;
  releaseInfo: string;
}

export function Watermark(props: WatermarkProps) {
  const { packageName, releaseInfo } = props;
  const licenseStatus = useLicenseVerifier(packageName, releaseInfo);

  if (licenseStatus === LicenseStatus.Valid) {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        pointerEvents: "none",
        color: "#8282829e",
        zIndex: 100000,
        width: "100%",
        textAlign: "center",
        bottom: "50%",
        right: 0,
        letterSpacing: 5,
        fontSize: 24,
      }}
    >
      {getLicenseErrorMessage(licenseStatus)}
    </div>
  );
}
